/**
 * @author Rohman Widiyanto
 * @email rohmansca@gmail.com
 * @create date 2022-01-13 15:45:17
 * @modify date 2022-01-13 15:45:17
 */
import { uniq, map } from 'lodash'
import { Instance, SnapshotOut, types, flow, applySnapshot, getSnapshot } from "mobx-state-tree"

import { ApiResult } from "services/api"
import { 
  withEnvironment,
  withGeneralError,
  withSetValue,
  withReset,
  withRootStore
} from "models/extensions"
import { DATA_PER_PAGE } from "config/env"

/**
 * Model description here for TypeScript hints.
 */
export const SupplierStoreModel = types
  .model("SupplierStore")
  .props({
    suppliers: types.optional(types.array(types.string), []),
    search: types.optional(types.string, ""),
    page: types.optional(types.number, 1),
    totalPage: types.optional(types.number, 0)
  })
  .extend(withEnvironment)
  .extend(withRootStore)
  .extend(withGeneralError)
  .extend(withSetValue)
  .extend(withReset)
  .actions(self=> ({
    setSuppliers(suppliers) {
      applySnapshot(self, {
        ...getSnapshot(self),
        suppliers: suppliers
      })
    }
  }))
  .actions(self => ({
    getSuppliers: flow(function * () {
      try {
        const res: ApiResult = yield self
          .environment
          .supplierApi
          .all({
            "size": DATA_PER_PAGE,
            "term": self.search
          })          

        if (res.kind === "ok") self.setSuppliers(uniq(map(res.data, 'name')))
      } catch (error: any) {
        yield self.checkForGeneralError(error)
      }
    }), 
  }))

type SupplierStoreType = Instance<typeof SupplierStoreModel>
export interface SupplierStore extends SupplierStoreType {}
type SupplierStoreSnapshotType = SnapshotOut<typeof SupplierStoreModel>
export interface SupplierStoreSnapshot extends SupplierStoreSnapshotType {}
